export default __webpack_public_path__ + "static/media/lifesatisfaction4Img1.9fc9b277.png";